import { createSlice } from "@reduxjs/toolkit";

// Type
import { Compound } from 'lib/prices';
import { TreeNode } from 'pages/Thesaurus/Thesaurus';

// Lib
import { listTree, getHeaderNodes } from 'lib/thesaurus';
import { checkAllCheckbox, updatedDataByKey, priceAvailable } from "lib/prices";
import Tree from 'rc-tree';

// Interface
export interface ICategory {
	key?: string;
	cdId: number;
	name: string;
	description: string;
	compoundsCount: number;
	children: ICategory[];
}

interface IInitialState {
	allItems?: TreeNode[];
	categoriesMenu?: TreeNode[];
	categories?: ICategory[];
	loading: boolean;

	loadingCategoriesById: boolean;
	categoriesById: any;

	categoryName?: string;
	categoryDescription?: string;

	typeViewList: string,

	goTo: number;
	paged: boolean;
	currPage: number;
	pageSize?: number;

	checkboxAll: boolean;
	toggleFilter: boolean;

	selectedKeys: string[] | [];
	expandedKeys: string[] | [];
}

const initialState: IInitialState = {
	categories: [],
	loading: false,

	loadingCategoriesById: false,
	categoriesById: [],

	typeViewList: 'row',

	goTo: 1,
	paged: true,
	currPage: 0,
	pageSize: 12,

	checkboxAll: false,
	toggleFilter: false,

	categoryName: '',
	categoryDescription: '',

	selectedKeys: [],
	expandedKeys: [],

	categoriesMenu: [],
	allItems: [],
};

export const pfizerSlice = createSlice({
	name: "pfizer",
	initialState,
	reducers: {
		updateExpandedKeys: (state, action) => {
			state.expandedKeys = action.payload;
		},
		updateSelectedKeys: (state, action) => {
			state.selectedKeys = action.payload;
		},

		changeToggleFilter: (state) => {
			state.toggleFilter = !state.toggleFilter;
		},

		updatePricesAll: (state, action) => {
			const prepackage = action.payload;

			state.categoriesById = state.categoriesById.map((item: Compound) => {
				const updatedItem = { ...item, currentPrice: prepackage };
				const canSelect =
					!updatedItem.isPOA &&
					updatedItem.onStock &&
					priceAvailable(updatedItem)?.available;

				return {
					...updatedItem,
					selected: state.checkboxAll && canSelect,
				};
			});
		},

		changeCheckboxAll: (state) => {
			state.checkboxAll = !state.checkboxAll;

			state.categoriesById = state.categoriesById.map((item: Compound) => {
				const canSelect =
					!item.isPOA &&
					item.onStock &&
					priceAvailable(item)?.available;

				return {
					...item,
					selected: state.checkboxAll && canSelect,
				};
			});
		},
		clearAllCheckbox: (state) => {
			state.checkboxAll = false;

			state.categoriesById = state.categoriesById.map((item: any) => ({
				...item,
				selected: false,
			}));
		},

		changeGoTo: (state, action) => {
			state.goTo = action.payload;
		},
		changeSize: (state, action) => {
			state.pageSize = action.payload;
		},
		changePage: (state, action) => {
			state.currPage = action.payload;
		},

		changeCurrentPriceType: (state, action) => {
			const id = action.payload.id;
			const type = action.payload.type;

			state.categoriesById = updatedDataByKey({
				id: id,
				value: type,
				key: 'currentTypePrice',
				data: state.categoriesById,
			});
		},
		changeQuantity: (state, action) => {
			const id = action.payload.id;
			const quantity = action.payload.quantity;

			state.categoriesById = updatedDataByKey({
				id: id,
				key: 'quantity',
				value: quantity,
				data: state.categoriesById,
			});
		},

		changeCheckboxItem: (state, action) => {
			const id = action.payload.id;

			const result = updatedDataByKey({
				id: id,
				value: "",
				key: 'selected',
				data: state.categoriesById,
			});

			state.categoriesById = result;
			state.checkboxAll = checkAllCheckbox(result);
		},
		changePriceItem: (state, action) => {
			const id = action.payload.id;
			const data = action.payload.data;

			state.categoriesById = updatedDataByKey({
				id: id,
				value: data,
				key: 'currentPrice',
				data: state.categoriesById,
			});
		},

		changeTypeViewList: (state, action) => {
			state.typeViewList = action.payload;
		},

		changeTitle: (state, action) => {
			state.categoryName = action.payload.categoryName;
			state.categoryDescription = action.payload.categoryDescription;
		},

		getCategories: (state) => {
			state.loading = true;
		},
		getCategoriesError: (state) => {
			state.loading = false;
		},
		getCategoriesSuccess: (state, action) => {
			const data = action.payload;

			const treeData: TreeNode[] = listTree({
				key: 'key',
				data: data,
				targetBox: [],
				inputValue: '',
				checkedKeys: []
			});

			const arrayMenu: TreeNode[] = getHeaderNodes(treeData);

			state.loading = false;
			state.categories = data;
			// @ts-ignore
			state.categoriesMenu = arrayMenu?.categoriesMenu;
			// @ts-ignore
			state.allItems = arrayMenu?.allItems;
		},

		getEbcCategoriesById: (state, action) => {
			state.loadingCategoriesById = true;
		},
		getEbcCategoriesByIdError: (state) => {
			state.loadingCategoriesById = false;
		},
		getEbcCategoriesByIdSuccess: (state, action) => {
			state.loadingCategoriesById = false;
			state.categoriesById = action.payload;
		},
	},
});

export const {
	changeTitle,

	updateExpandedKeys,
	updateSelectedKeys,

	changeToggleFilter,

	updatePricesAll,

	clearAllCheckbox,
	changeCheckboxAll,

	changeGoTo,
	changeSize,
	changePage,

	changeCurrentPriceType,
	changePriceItem,
	changeQuantity,
	changeCheckboxItem,

	changeTypeViewList,

	getCategories,
	getCategoriesError,
	getCategoriesSuccess,

	getEbcCategoriesById,
	getEbcCategoriesByIdError,
	getEbcCategoriesByIdSuccess,
} = pfizerSlice.actions;

export default pfizerSlice.reducer;
